// extracted by mini-css-extract-plugin
var _1 = "Media_readonly__a201c";
var _2 = "Media_root__73527";
export { _1 as "readonly", _2 as "root" }
